import React, { useEffect, useState } from 'react';
import axios from 'axios';

const StudExamDetails = () => {
  const [student, setStudent] = useState(null); // single student object, not an array
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const userId = localStorage.getItem('UserId'); // Assuming userId is stored in localStorage

  useEffect(() => {
    if (userId) {
      const fetchStudentDetails = async () => {
        try {
          const res = await axios.get(`${process.env.REACT_APP_API}/students/id/${userId}`);
          setStudent(res.data); // Setting the student data to state
          setLoading(false); // Turn off loading once data is fetched
        } catch (err) {
          console.error('Error fetching student details:', err);
          setLoading(false);
          setError('Failed to load student details. Please try again later.');
        }
      };

      fetchStudentDetails();
    } else {
      setLoading(false);
      setError('User ID not found. Please log in.');
    }
  }, [userId]); // Triggered only if userId changes

  if (loading) {
    return <p>Loading student details...</p>; // Show loading message if still loading
  }

  if (error) {
    return <p style={{ color: 'red' }}>{error}</p>; // Display error message if there's an error
  }

  return (
    <div style={{ padding: 20 }}>
      <h2>Please note your student ID for your examination:</h2>

      {student ? (
        <table border="1" style={{ marginTop: 20 }}>
          <thead>
  <tr>
    <th>Student ID</th>
    <th>Name</th>
    <th>Father's Name</th>
    <th>School</th>
    <th>Medium</th>
    <th>Standard</th>
    <th>Payment Status</th>
    <th>Created At</th>
  </tr>
</thead>
<tbody>
  <tr>
    <td>{student.student_id}</td>
    <td>{student.name}</td>
    <td>{student.father_name}</td>
    <td>{student.school}</td>
    <td>{student.medium}</td>
    <td>{student.standard}</td>
    <td>{student.payment_status}</td>
    <td>{new Date(student.created_at).toLocaleDateString()}</td>
  </tr>
</tbody>

          <tbody>
            <tr>
              <td>{student.student_id}</td>
              <td>{student.name}</td>
              <td>{student.school}</td>
              <td>{student.payment_status}</td>
            </tr>
          </tbody>
        </table>
      ) : (
        <p>No student data available.</p> // Show message if no student data exists
      )}
    </div>
  );
};

export default StudExamDetails;
